import chalet from '@8x8/chalet'
import { Interfaces } from '@8x8/chalet-proto'

import envData from '~/core/env'
import { logInfo } from '~/core/logger'

let connection
let DefaultProxy

export const initChalet = token => {
  const discoveryUrl = envData.chaletUrl

  chalet.init({
    discoveryUrl,
    token
  })

  const connection = {
    connection: chalet,
    DefaultProxy: Interfaces.DefaultProxy
  }

  return connection
}

export const setChalet = lib => {
  if (!lib) {
    return
  }

  ({ connection, DefaultProxy } = lib)
  logInfo({ __filename }, 'Chalet lib set')
}

export default {
  get connection () {
    return connection
  },
  get DefaultProxy () {
    return DefaultProxy
  }
}
